<template lang="pug">
  footer.b-footer
    ._container.container
        span._copy &copy;&nbsp;TeRoom {{ (new Date).getFullYear() }}
        FooterSupport._support
</template>

<script>
import FooterSupport from '@/components/FooterSupport.vue';
import FooterEmail from '@/components/FooterEmail.vue';
import FooterMenu from '@/components/FooterMenu.vue';

export default {
  name: 'TheFooter',
  components: { FooterMenu, FooterEmail, FooterSupport },
};
</script>

<style scoped lang="scss">
.footer {
  background-color: var(--color-dark-gray);
  color: var(--color-white);

  &__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 0;
  }

  &__copy {
    font-size: 11px;
    line-height: 16px;
    color: var(--color-purple);
  }

  @media (max-width: 1500px) {
    &__container {
      padding: 24px 45px;
    }
  }

  @media (max-width: 1024px) {
    &__container {
      padding: 25px;
    }
  }

  @media (max-width: 450px) {
    &__container {
      padding: 20px 16px;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }
  }
}
</style>
